export const WIDGET_ID_QUERY_PARAM = 'widgetId'
